// extracted by mini-css-extract-plugin
export default {"centeredOverdue":"CourseIndividuals_centeredOverdue__nk6Oe","statusBadge":"CourseIndividuals_statusBadge__Jhxhy"};